let activeController = null;
let activePromise = null;
let activeKey = null;

const buildKey = (params = {}) => JSON.stringify(params || {});

export const isInvoiceRequestCanceled = (error) => (
  error?.name === 'CanceledError' ||
  error?.code === 'ERR_CANCELED' ||
  error?.message === 'canceled'
);

export const invoiceRequestManager = {
  request(params, fetchFn) {
    const key = buildKey(params);

    if (activePromise && activeKey === key) {
      return activePromise;
    }

    if (activeController) {
      activeController.abort();
    }

    const controller = new AbortController();
    activeController = controller;
    activeKey = key;

    activePromise = fetchFn(controller.signal).finally(() => {
      if (activeController === controller) {
        activeController = null;
        activePromise = null;
        activeKey = null;
      }
    });

    return activePromise;
  },

  cancel() {
    if (activeController) {
      activeController.abort();
    }
    activeController = null;
    activePromise = null;
    activeKey = null;
  }
};
